import { useState } from 'react'
import Input from '../../../../Core/Fields/Floating/Input';
import SelectSearch from '../../../../Core/Fields/Floating/SelectSearch';
import { useGetCountryListQuery } from '../../../../store/api/companyapi'
import { useGetTaxcategoryQuery } from '../../../../store/api/customer'
const Tab1 = ({ formdata, handleChange, setFormData }) => {

    const stateOptions =[
        { "name": "Andhra Pradesh" },
        { "name": "Arunachal Pradesh" },
        { "name": "Assam" },
        { "name": "Bihar" },
        { "name": "Chhattisgarh" },
        { "name": "Goa" },
        { "name": "Gujarat" },
        { "name": "Haryana" },
        { "name": "Himachal Pradesh" },
        { "name": "Jharkhand" },
        { "name": "Karnataka" },
        { "name": "Kerala" },
        { "name": "Madhya Pradesh" },
        { "name": "Maharashtra" },
        { "name": "Manipur" },
        { "name": "Meghalaya" },
        { "name": "Mizoram" },
        { "name": "Nagaland" },
        { "name": "Odisha" },
        { "name": "Punjab" },
        { "name": "Rajasthan" },
        { "name": "Sikkim" },
        { "name": "Tamil Nadu" },
        { "name": "Telangana" },
        { "name": "Tripura" },
        { "name": "Uttar Pradesh" },
        { "name": "Uttarakhand" },
        { "name": "West Bengal" },
        { "name": "Andaman and Nicobar Islands" },
        { "name": "Chandigarh" },
        { "name": "Dadra and Nagar Haveli and Daman and Diu" },
        { "name": "Delhi" },
        { "name": "Jammu and Kashmir" },
        { "name": "Ladakh" },
        { "name": "Lakshadweep" },
        { "name": "Puducherry" }
    ]
    const addrsstype = [{ "name": "Billing" }, { "name": "Shipping" }, { "name": "Office" }, { "name": "Personal" }, { "name": "Plant" }, { "name": "Postal" }, { "name": "Shop" }, { "name": "Subssidiary" }, { "name": "Warehouse" }, { "name": "Current" }, { "name": "Permananent" }, { "name": "Other" }]

    const [selectedCompany, setSelectedCompany] = useState('')
    const [isGroup, setIsGroup] = useState(0)
    const { data: countrydata, isLoading: countryLoader } = useGetCountryListQuery();
    const { data: taxcatData, taerror, taisLoading } = useGetTaxcategoryQuery();



    return (
        <div
            className="row "
            style={{ border: "1px solid #00000059", borderRadius: "5px" }}
        >
            <div className="col-12">
                <p className="boxLabel m-0"> Address Details</p>
            </div>

            <div>
                <div className="d-flex" style={{ gap: '1rem', width: '100%' }}>
                    <div style={{ flex: '1' }}>
                        <div className="mb-3">
                            <Input
                                name="addressTitle"
                                value={formdata.addressTitle}
                                onChange={handleChange}
                                label="Address Title"
                                style={{ height: "30px" }}
                            />
                        </div>
                    </div>
                    <div style={{ flex: '1' }}>
                        <div className="mb-3">
                            <SelectSearch
                                list={addrsstype || []}
                                label="Customer Type"
                                value={formdata.AddressType}
                                onChange={(val) =>
                                    setFormData((prev) => ({
                                        ...prev,
                                        AddressType: val,
                                    }))
                                }
                                getOptionLabel={(item) => item.name}
                                getOptionValue={(item) => item.name}
                                placeholder=""
                            />
                        </div>
                    </div>
                    <div style={{ flex: '1' }}>
                        <div className="mb-3">
                            <Input
                                name="AddressLine1"
                                value={formdata.AddressLine1}
                                label="Address Line1"
                                onChange={handleChange}
                                style={{ height: "30px" }}
                            />
                        </div>
                    </div>
                    <div style={{ flex: '1' }}>
                        <div className="mb-3">
                            <Input
                                name="AddressLine2"
                                value={formdata.AddressLine2}
                                label="Address Line2"
                                onChange={handleChange}
                                style={{ height: "30px" }}
                            />
                        </div>
                    </div>
                </div>
            </div>
            <div>
                <div className="d-flex" style={{ gap: '1rem', width: '100%' }}>
                    <div style={{ flex: '1' }}>
                        <div className="mb-3">
                            <SelectSearch
                                list={countrydata?.data || []}
                                label="County"
                                value={formdata.Country}
                                onChange={(val) =>
                                    setFormData((prev) => ({
                                        ...prev,
                                        Country: val,
                                    }))
                                }
                                getOptionLabel={(item) => item.name}
                                getOptionValue={(item) => item.name}
                                placeholder=""
                            />
                        </div>
                    </div>
                    <div style={{ flex: '1' }}>
                        <div className="mb-3">
                                <SelectSearch
                                list={stateOptions|| []}
                                label="State/Province"
                                value={formdata.State}
                                onChange={(val) =>
                                    setFormData((prev) => ({
                                        ...prev,
                                        State: val,
                                    }))
                                }
                                getOptionLabel={(item) => item.name}
                                getOptionValue={(item) => item.name}
                                placeholder=""
                            />
                        </div>
                    </div>
                    <div style={{ flex: '1' }}>
                        <div className="mb-3">
                            <Input
                                name='City'
                                label="City/Town"
                                value={formdata.City}
                                onChange={handleChange}
                                style={{ height: "30px" }}
                            />
                        </div>
                    </div>
                    <div style={{ flex: '1' }}>
                        <div className="mb-3">
                            <Input
                                name='postalCode'
                                label="Postal Code"
                                value={formdata.postalCode}
                                onChange={handleChange}
                                style={{ height: "30px" }}
                            />
                        </div>
                    </div>
                </div>
            </div>
            <div>
                <div className="d-flex" style={{ gap: '1rem', width: '100%' }}>
                    <div style={{ flex: '1' }}>
                        <div className="mb-3">
                            <Input
                                label="Email Address"
                                name='email'
                                value={formdata.email}
                                onChange={handleChange}
                                style={{ height: "30px" }}
                            />
                        </div>
                    </div>
                    <div style={{ flex: '1' }}>
                        <div className="mb-3">
                            <Input
                                label="Phone"
                                name='phone'
                                value={formdata.phone}
                                onChange={handleChange}
                                style={{ height: "30px" }}
                            />
                        </div>
                    </div>
                    <div style={{ flex: '1' }}>
                        <div className="mb-3">
                            <Input
                                name='Fax'
                                label="Fax"
                                value={formdata.Fax}
                                onChange={handleChange}
                                style={{ height: "30px" }}
                            />
                        </div>
                    </div>
                    <div style={{ flex: '1' }}>
                        <div className="mb-3">
                            <SelectSearch
                                list={taxcatData?.data || []}
                                label="Tax Category"
                                value={formdata.taxCategory}
                                onChange={(val) =>
                                    setFormData((prev) => ({
                                        ...prev,
                                        taxCategory: val,
                                    }))
                                }
                                getOptionLabel={(item) => item.name}
                                getOptionValue={(item) => item.name}
                                placeholder=""
                            />
                        </div>
                    </div>
                </div>
            </div>
            <div className='d-flex mx-3 mt-2 mb-3' style={{ gap: '160px', fontSize: '10px', color: '#00000099' }}>
                <div>
                     <input
                        type="checkbox"
                        name='pba'
                        label=''
                        style={{ width: '10px', height: '10px' }}
                        value={formdata.pba}
                        onChange={handleChange}
                    />
                    <label htmlFor="defaultCheck" style={{ marginLeft: '0.5rem' }}>Preferred Billing Address</label>
                </div>
                <div className='mx-3'>
                    <input
                        type="checkbox"
                        style={{ width: '10px', height: '10px' }}
                        name='psa'
                        value={formdata.psa}
                        onChange={handleChange}
                    />
                    <label htmlFor="defaultCheck" style={{ marginLeft: '0.5rem' }}>Preferred Shipping Address</label>
                </div><div>
                    <input
                        type="checkbox"
                        style={{ width: '10px', height: '10px' }}
                        name='Disabled'
                        value={formdata.Disabled}
                        onChange={handleChange}
                    />
                    <label htmlFor="defaultCheck" style={{ marginLeft: '0.5rem' }}>Disabled</label>
                </div>
            </div>
        </div>
    )
}

export default Tab1